import { createTheme, MuiThemeProvider } from '@material-ui/core';
import { KeyboardTimePicker } from '@material-ui/pickers';
import colours from 'bz-core-controls/styles/colours';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import moment from 'moment';
import React from 'react';

@observer
class TimePickerWrapper extends React.Component {
  static defaultProps = {
    onChange: () => null
  };

  @observable opened = false;
  @observable selected = undefined;

  render() {
    return (
      <MuiThemeProvider theme={this.theme}>
        <KeyboardTimePicker
          {...this.props}
          open={this.opened}
          value={this.value}
          onAccept={this.onAccept}
          onChange={this.onChange}
          onClose={this.onClose}
          onOpen={this.onOpen}
        />
      </MuiThemeProvider>
    );
  }

  @computed
  get value() {
    return this.selected || this.props.value;
  }

  @action.bound
  onOpen() {
    this.opened = true;
  }

  @action.bound
  onAccept(value) {
    this.props.onChange(value.toDate());
  }

  @action.bound
  onChange(v) {
    if (!!v && v.isValid()) {
      if (this.opened) {
        this.selected = v.toDate();
        return;
      }

      const d = new Date(this.props.value).toDateString();
      let datetime = moment(d);
      datetime.hours(v.hours());
      datetime.minutes(v.minutes());

      this.props.onChange(datetime.toDate());
    }
  }

  @action.bound
  onClose() {
    this.opened = false;
    this.selected = undefined;
  }

  theme(args) {
    return createTheme({
      ...args,
      palette: {
        contrastThreshold: 2,
        primary: {
          main: colours.lightBlue
        }
      },
      overrides: {
        MuiButton: {
          root: {
            height: 'unset'
          }
        },
        MuiInput: {
          root: { fontSize: '14px', fontWeight: 400 },
          inputType: { height: 'auto' },
          underline: {
            '& input[required]': {
              borderBottom: `1px solid ${colours.yellow}`,
              zIndex: 2
            }
          }
        }
      }
    });
  }
}

export default TimePickerWrapper;
